import ProfessionalService from '../../../../../services/professional_service';
import StudentService from '../../../../../services/student_service';

const Profile = (vm) => {
  const syncProfessionalProfile = async () => {
    try {
      const getProfessional = await ProfessionalService.get(vm.userId);
      if (vm.logout(getProfessional)) return false;
      if (getProfessional) {
        await ProfessionalService.update(vm.userId, {
          Title: vm.formDataProfesional.profession.trim(),
          Name: vm.formDataProfesional.company.trim(),
          Position: vm.formDataProfesional.currentPosition.trim(),
        });
      } else {
        await ProfessionalService.create({
          Title: vm.formDataProfesional.profession.trim(),
          Name: vm.formDataProfesional.company.trim(),
          Position: vm.formDataProfesional.currentPosition.trim(),
          FK_Contact: String(vm.userId),
        });
        await StudentService.delete(vm.userId);
      }
      return true
    } catch (e) {
      vm.message(e?.message || e, "error");
      return false
    }
  };

  const syncStudentProfile = async () => {
    try {
      const getStudent = await StudentService.get(vm.userId);
      if (vm.logout(getStudent)) return false;
      if (getStudent) {
        await StudentService.update(vm.userId, {
          Level: vm.formDataEstudiante.studyLevel.trim(),
          Career: vm.formDataEstudiante.career.trim(),
          Name: vm.formDataEstudiante.university.trim(),
          Semester: Number(vm.formDataEstudiante.semester),
        });
      } else {
        await StudentService.create({
          Level: vm.formDataEstudiante.studyLevel.trim(),
          Career: vm.formDataEstudiante.career.trim(),
          Name: vm.formDataEstudiante.university.trim(),
          Semester: Number(vm.formDataEstudiante.semester),
          FK_Contact: String(vm.userId),
        });
        await ProfessionalService.delete(vm.userId);
      }
      return true
    } catch (e) {
      vm.message(e?.message || e, "error");
      return false
    }
  };

  const syncProfessionalOrStudentUpdate = async () => {
    if (vm.formDataUser.stage === 'Profesional') {
      return await syncProfessionalProfile();
    }
    if (vm.formDataUser.stage === 'Estudiante') {
      return await syncStudentProfile();
    }
    return true;
  };

  return {
    syncProfessionalOrStudentUpdate,
  };
};

export default Profile;
